import { MenuItem, Typography } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Form } from "formik";
import * as Yup from "yup";
import CustomDialog from "../../../commons/dialog/customDialog";
import FormikActions from "../../../commons/formik/formikActions";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextFieldSpeech from "../../../commons/formik/formikTextFieldSpeech";

const validation = (configuration) =>
  Yup.object({
    tipo: Yup.lazy((value) => {
      if (configuration.typifyAttachmentFile) {
        return Yup.number().required("Campo obligatorio");
      } else {
        return Yup.number();
      }
    }),
    observaciones: Yup.lazy((value) => {
      if (
        configuration.requiresAttachmentObservation &&
        configuration.showAttachmentObservation
      ) {
        return Yup.string().required("Campo obligatorio").nullable().max(500, "El campo no puede superar los 500 caracteres");
      } else {
        return Yup.string().nullable().max(500, "El campo no puede superar los 500 caracteres");
      }
    }),
  });

const FileTypeDialog = ({
  file,
  open,
  handleClose,
  handleSubmit,
  configuration,
  isEditingFile,
  deleteLastFile,
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          width: {
            xs: 'min(90vw, 90dvw)',
          },
          maxWidth: {
            xs: 'xs',
            sm: 'sm',
          },
        },
      }}
    >
      <DialogTitle>Tipificar adjunto</DialogTitle>
      <FormikForm
        initialValues={file}
        validationSchema={() => validation(configuration)}
        onSubmit={(values) => {
          handleSubmit({
            ...values,
            filename: file.nombre ?? file.name ?? file.filename,
          });
        }}>
        <Form>

          <DialogContent>
            {/* cuando se está editando el formulario, tenemos disponible */}
            {/* file.filename. Cuando estamos cargando el formulario desde */}
            {/* el back, tenemos disponible file.nombre */}
            {/* Cuando tenemos un archivo seleccionado desde el explorador */}
            {/* de archivos por el dropzone, tenemos file.name */}
            <Typography>{file.nombre ?? file.name ?? file.filename}</Typography>
            {configuration.typifyAttachmentFile && (
              <FormikSelect name="tipo" value={file.tipo} label="Tipo">
                {configuration.typifyAttachmentFile.map((t) => (
                  <MenuItem value={t.tipoAdjunto} key={t.tipoAdjunto}>
                    {t.nombre}
                  </MenuItem>
                ))}
              </FormikSelect>
            )}
            {configuration.showAttachmentObservation && (
              <FormikTextFieldSpeech
                margin="dense"
                id="observaciones"
                name="observaciones"
                label="Observaciones"
                type="text"
                multiline
                fullWidth
              />
            )}
          </DialogContent>
          <DialogActions>
            <FormikActions
              handleCancel={() => {
                handleClose();
                if (!isEditingFile) {
                  deleteLastFile();
                }
              }}
            />
          </DialogActions>
        </Form>
      </FormikForm>
    </CustomDialog>
  );
};

export default FileTypeDialog;
